// Copyright (c) 2016 Deere & Company

import ClaimDetailsContainer from './claim-details-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    claim: state.claims.massChannelPdi.claim,
    formValidation: state.claims.massChannelPdi.formValidation,
    goodsInstallationVatOptions: state.claims.goodsInstallationVatOptions,
    isEditable: state.claims.massChannelPdi.isEditable,
    isValidClaim: state.claims.massChannelPdi.isValidClaim,
    retailerNameCollection: state.claims.massChannelPdi.retailerNameCollection,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClaimDetailsContainer);



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/components/claim-details-section/index.js